import Phaser from 'phaser';
import './styles.css';

document.body.dataset.loading = 'true';

// The complete game is initialized after the scene modules are loaded.
Promise.all([
  import('./config.js'),
  import('./core/AudioManager.js'),
  import('./core/InputController.js'),
  import('./core/uiBus.js'),
  import('./scenes/BootScene.js'),
  import('./scenes/MenuScene.js'),
  import('./scenes/GameScene.js'),
  import('./scenes/WinScene.js'),
]).then(([
  { FREEBIE_URL, GAME },
  { audioManager },
  { bindDocumentControls, inputBus },
  { uiBus },
  { BootScene },
  { MenuScene },
  { GameScene },
  { WinScene },
]) => {
  const menuPanel = document.querySelector('#menu-panel');
  const winPanel = document.querySelector('#win-panel');
  const freebieLink = document.querySelector('#freebie-link');
  const muteButton = document.querySelector('#mute-button');
  const status = document.querySelector('#game-status');

  freebieLink.href = FREEBIE_URL;

  const showPanel = (mode, message = '') => {
    menuPanel.hidden = mode !== 'menu';
    winPanel.hidden = mode !== 'win';
    status.textContent = message;
  };

  uiBus.addEventListener('modechange', (event) => {
    showPanel(event.detail.mode, event.detail.message);
  });

  inputBus.addEventListener('command', (event) => {
    audioManager.unlock();
    if (event.detail.command !== 'mute') return;

    const muted = audioManager.toggleMuted();
    muteButton.setAttribute('aria-pressed', String(muted));
    muteButton.setAttribute('aria-label', muted ? 'Unmute game sounds' : 'Mute game sounds');
    muteButton.querySelector('span').textContent = muted ? 'Sound: Off' : 'Sound: On';
  });

  const unbindControls = bindDocumentControls(document);

  const game = new Phaser.Game({
    type: Phaser.AUTO,
    parent: 'game-root',
    width: GAME.WIDTH,
    height: GAME.HEIGHT,
    backgroundColor: '#2131A5',
    physics: {
      default: 'arcade',
      arcade: {
        gravity: { y: GAME.GRAVITY },
        debug: false,
      },
    },
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    render: {
      antialias: true,
      pixelArt: false,
    },
    scene: [BootScene, MenuScene, GameScene, WinScene],
  });

  window.addEventListener('beforeunload', () => {
    unbindControls();
    game.destroy(true);
  });

  document.body.dataset.loading = 'false';
}).catch((error) => {
  console.error('Chemistry Hallway Dash could not start.', error);
  const status = document.querySelector('#game-status');
  status.textContent = 'The game could not start. Please refresh and try again.';
  document.body.dataset.loading = 'false';
});
